module.exports = __webpack_public_path__ + "33c5b0e0ce4d1a4b52ad278742f64609.png";